<template>
  <div>
    <div class="orderReview div-layout">
      <module-title title="组织订单审核">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-download" @click="handleExport">
            导出
          </el-button>
        </div>
      </module-title>
      <div class="form-box">
        <el-form ref="orderSearchForm" :model="searchForm" :inline="true" label-position="right" class="subjectSearchForm">
          <el-form-item label="姓名：" prop="organizationAdminName">
            <el-input v-model="searchForm.organizationAdminName" name="organizationAdminName" maxlength="200" placeholder="输入姓名" class="handle-form-input" clearable />
          </el-form-item>
          <el-form-item label="组织名称：" prop="organizationName">
            <el-input v-model="searchForm.organizationName" name="organizationName" maxlength="200" placeholder="输入组织名称" class="handle-form-input" clearable />
          </el-form-item>
          <el-form-item label="业务订单号：" prop="orderCode">
            <el-input v-model="searchForm.orderCode" name="orderCode" maxlength="200" placeholder="输入业务订单号" class="handle-form-input" clearable />
          </el-form-item>
          <el-form-item label="手机号：" prop="phoneNumber">
            <el-input v-model="searchForm.phoneNumber" name="phoneNumber" maxlength="11" placeholder="请输入手机号" class="handle-form-input" @change="inputNum($event,'phoneNumber')" @input="inputNum($event,'phoneNumber')" />
          </el-form-item>
          <el-form-item label="组织类型：" prop="organizationTypeCode">
            <el-select v-model="searchForm.organizationTypeCode" name="organizationTypeCode" size="medium">
              <el-option label="全部" value="" />
              <el-option v-for="(item,index) in organList" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态：" prop="approvalStatus">
            <el-select v-model="searchForm.approvalStatus" size="medium">
              <el-option label="全部" value="" />
              <el-option label="审核不通过" :value="-1" />
              <el-option label="待审核" :value="0" />
              <el-option label="审核通过" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tab-box">
        <el-table v-loading="listLoading" :data="viewData" highlight-current-row fit element-loading-text="Loading" class="list-table">
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="业务订单号" prop="orderCode" align="center" width="150" />
          <el-table-column label="支付单号" prop="thirdPaymentCode" align="center" />
          <el-table-column label="姓名" prop="organizationAdminName" align="center" />
          <el-table-column label="手机号" prop="organizationAdminPhone" align="center" width="120" />
          <el-table-column label="区域" prop="provinceCityAreaName" align="center" width="160">
            <template slot-scope="scope">
              {{ scope.row.provinceCityAreaName }}
            </template>
          </el-table-column>
          <el-table-column label="组织名称" prop="organizationName" align="center" width="160" />
          <el-table-column label="组织类型" prop="organizationTypeName" align="center" width="140" />
          <el-table-column label="授权账号数（个）" prop="authorizationQuantity" align="center" width="160" />
          <el-table-column label="授权库存有效期（月）" prop="authorizationActivationTerm" align="center" width="160" />
          <el-table-column label="授权期限（月）" prop="authorizationTerm" align="center" width="120" />
          <el-table-column label="实付金额（元）" prop="afterDiscountAmount" align="center" width="120" />
          <el-table-column label="订单状态" prop="approvalStatusName" align="center" />
          <el-table-column label="操作" align="center" width="100px">
            <template slot-scope="scope">
              <el-button v-if="scope.row.approvalStatus=='0'" type="primary" size="small" @click="handleDialog('process',scope.row)">
                审核
              </el-button>
              <el-button v-else type="primary" size="small" @click="handleDialog('look',scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination :total="pageObj.total" :page.sync="pageObj.pageNum" :limit.sync="pageObj.pageSize" @pagination="pageCurriculumList" @handleSizeChange="handleSizeChange" />
      </div>
      <el-dialog v-if="dialogLookVisible" :close-on-click-modal="false" :visible.sync="dialogLookVisible" :title="dialogTitle" width="700px">
        <div class="detail-box">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="9">
              <div>业务订单号：{{ detailInfo.orderCode }}</div>
            </el-col>
            <el-col :span="9">
              <div>支付单号：{{ detailInfo.thirdPaymentCode }}</div>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="9">
              <div>手机号：{{ detailInfo.organizationAdminPhone }}</div>
            </el-col>
            <el-col :span="9">
              <div>姓名：{{ detailInfo.organizationAdminName }}</div>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="9">
              <div>区域：{{ detailInfo.provinceCityAreaName }}</div>
            </el-col>
            <el-col :span="9">
              <div>授权账号数（个）：{{ detailInfo.authorizationQuantity }}</div>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="9">
              <div>授权期限（月）：{{ detailInfo.authorizationTerm }}</div>
            </el-col>
            <el-col :span="9">
              <div>组织名称：{{ detailInfo.organizationName }}</div>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="9">
              <div>组织类型：{{ detailInfo.organizationTypeName }}</div>
            </el-col>
            <el-col :span="9">
              <div>实付金额（元）：{{ detailInfo.afterDiscountAmount }}</div>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="18">
              <span>支付凭证：</span>
              <el-image :src="detailInfo.voucherPictureUrl" :preview-src-list="[detailInfo.voucherPictureUrl]" style="width: 400px; height: 200px; vertical-align: text-top;" fit="cover" />
            </el-col>
          </el-row>
          <el-row v-for="(item,index) in detailInfo.orderApprovalHistoryList" v-show="isView==false" :key="index" type="flex" class="row-bg" justify="space-between">
            <el-col :span="18">
              <div>审核记录：{{ item.approvalDatetime }}  订单{{ item.approvalStatus===0 ? '待审核':item.approvalStatus===-1 ? '审核拒绝':'审核通过' }}，原因：{{ item.approvalReason }}</div>
              <div style="margin:20px 0;">
                审核人：{{ item.approvalPhone }}
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-if="isView==true" slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogLookVisible=false">
            取消
          </el-button>
          <!-- <el-button type="primary" size="medium" v-show="isView==false">确定</el-button> -->
          <el-button v-show="isView==true" type="primary" size="medium" :loading="ajaxLoading" @click="handleAudit(detailInfo)">
            {{ ajaxLoading ? "Loading" : "审核" }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog v-if="dialogProcessVisible" :close-on-click-modal="false" :visible.sync="dialogProcessVisible" title="审核" width="400px" @close="closeProcessDialog">
        <div>支付凭证是否与公司进账匹配，若匹配则可确认审核通过，若审核不通过，则需填写审核不通过原因</div>
        <div style="margin-top:20px">
          <el-input v-model="approvalData.approvalReason" type="textarea" maxlength="100" :show-word-limit="true" :rows="6" resize="none" placeholder="请输入内容" />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="reviewFailed">
            审核不通过
          </el-button>
          <el-button type="primary" size="medium" @click="approved">
            审核通过
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getOrgOrdersList, getOrgOrdersInfo, exportOrgOrdersExcel, orgOrdersApprove, orgOrdersReject, getOrganizationsTypes } from '@/api/yzdPlatformManage/orderManage';
import { deepCopy } from '@/utils/index.js';
import { getUserInfo } from '@/utils/auth';
export default {
  data() {
    return {
      listLoading: false,
      ajaxLoading: false,
      searchForm: {
        organizationAdminName: '', // 教师姓名
        phoneNumber: '', // 电话号码
        organizationTypeCode: '', // 组织机构类型编码
        organizationName: '', // 组织机构名称
        orderCode: '', // 订单编码
        approvalStatus: ''// 审核状态（-1：审核拒绝，0：待审核，1：审核通过）
      },
      pageObj: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      dialogLookVisible: false,
      dialogTitle: '',
      viewData: [],
      option: {},
      detailInfo: {},
      isView: false,
      dialogProcessVisible: false,
      approvalData: {
        orderId: '',
        approvalReason: '',
        approvalPhone: ''
      },
      organList: []
    };
  },
  mounted() {
    this.getTypes();
    this.getTableList();
  },
  methods: {
    getTypes() {
      getOrganizationsTypes().then(res => {
        if (res.code === '0') {
          this.organList = res.data;
        }
      });
    },
    inputNum(value, item) {
      this.searchForm[item] = value.replace(/^\.+|[^\d.]/g, '');
    },
    // 分页
    pageCurriculumList(obj) {
      this.pageObj.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = obj.limit;
      this.getTableList();
    },
    handleSearchFilter() {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = 10;
      this.option = {
        organizationAdminName: this.searchForm.organizationAdminName, // 教师姓名
        phoneNumber: this.searchForm.phoneNumber, // 电话号码
        organizationTypeCode: this.searchForm.organizationTypeCode, // 组织机构类型编码
        organizationName: this.searchForm.organizationName, // 组织机构名称
        orderCode: this.searchForm.orderCode, // 订单编码
        approvalStatus: this.searchForm.approvalStatus // 审核状态（-1：审核拒绝，0：待审核，1：审核通过）
      };
      this.getTableList();
    },
    getTableList() {
      this.listLoading = true;
      getOrgOrdersList({ ...this.option, pageNum: this.pageObj.pageNum, pageSize: this.pageObj.pageSize }).then((res) => {
        if (res.data && res.data.list && res.data.list.length) {
          this.viewData = res.data.list;
          this.pageObj.total = res.data.total;
        } else {
          this.viewData = [];
          this.pageObj.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.viewData = [];
        this.pageObj.total = 0;
        this.listLoading = false;
      });
    },
    handleDialog(type, row) {
      if (type === 'look') {
        this.dialogTitle = '查看订单';
        this.isView = false;
        this.getDetailInfo(row.orderId);
      } else {
        this.dialogTitle = '订单审核';
        this.isView = true;
        this.getDetailInfo(row.orderId);
      }
      this.dialogLookVisible = true;
    },
    getDetailInfo(orderId) {
      getOrgOrdersInfo({ id: orderId }).then(res => {
        this.detailInfo = res.data;
      });
    },
    handleExport() {
      const op = deepCopy(this.searchForm);
      window.location.href = exportOrgOrdersExcel(op);
    },
    handleAudit(data) {
      this.approvalData.orderId = data.orderId;
      this.approvalData.approvalPhone = getUserInfo().phone;
      this.dialogProcessVisible = true;
    },
    closeProcessDialog() {
      this.dialogProcessVisible = false;
      this.approvalData = {
        orderId: '',
        approvalReason: ''
      };
    },
    // 审核通过
    approved() {
      orgOrdersApprove(this.approvalData).then(res => {
        this.dialogLookVisible = false;
        this.dialogProcessVisible = false;
        this.closeProcessDialog();
        this.getTableList();
        this.$notify.success({ title: 'Success', message: '操作成功', showClose: false, duration: 2000 });
      });
    },
    // 审核不通过
    reviewFailed() {
      orgOrdersReject(this.approvalData).then(res => {
        this.dialogLookVisible = false;
        this.dialogProcessVisible = false;
        this.closeProcessDialog();
        this.getTableList();
        this.$notify.success({ title: 'Success', message: '操作成功', showClose: false, duration: 2000 });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.orderReview{
  .form-box{
    padding: 0 30px;
  }
  .row-bg{
    margin-bottom: 20px;
  }
}
</style>
